// extracted by mini-css-extract-plugin
export default {"leftWidthStyling":"aboutYou__leftWidthStyling___EgKf8","rightWidthStyling":"aboutYou__rightWidthStyling___g0HbU"};